import React, { useEffect, useState } from "react";
import { getSourceRefs } from "./services/getSourceRefs";
import { ReferenceType } from "../FpAppV4/utils/fpAppV4Interface";
import { useDispatch } from "react-redux";
import clsx from "clsx";
import { Popover } from "@mui/material";
import { Telescope } from "lucide-react";
import { setFileViewerData } from "@/redux/fileViewerSlice";

const CiteNumber = ({
  originalNumValue,
  numValue,
  qid,
}: {
  originalNumValue: string;
  numValue: string;
  qid: string;
}) => {
  const [sourceRefs, setSourceRefs] = useState<ReferenceType[]>([]);
  const [anchorEl, setAnchorEl] = useState<HTMLSpanElement | null>(null);
  const dispatch = useDispatch();

  // useEffect(() => {
  //   const sourceRefs = await getSourceRefs(qid, numValue);
  //   setSourceRefs(sourceRefs);
  // }, [qid, numValue]);

  const clickRef = (ref: ReferenceType) => {
    dispatch(
      setFileViewerData({
        isOpen: true,
        fileId: ref.docId || "",
        fileName: ref?.blobFilename || ref?.docTitle || "",
        fileType: "excel",
        highlightContext: ref.smallContext,
        highlightPageNum: ref.pageNum,
        originalNumValue,
      })
    );
  };

  const handleCiteNumberClick = (e: React.MouseEvent<HTMLSpanElement>) => {
    const length = sourceRefs.length;
    if (length > 1) {
      setAnchorEl(e.currentTarget);
    }
    if (length === 1) {
      const ref = sourceRefs[0];
      clickRef(ref);
    }
  };

  return (
    <>
      <span
        className={clsx(
          sourceRefs.length > 0 ? "text-blue-700 cursor-pointer" : ""
        )}
        onClick={(e) => {
          (window as any).fp?.editor?.commands?.blur();
          handleCiteNumberClick(e);
        }}
      >
        {originalNumValue}
      </span>
      <Popover
        id={anchorEl ? "simple-popover" : undefined}
        open={anchorEl !== null}
        anchorEl={anchorEl}
        onClose={(e, reason) => {
          setAnchorEl((prev) => {
            console.log("prev", prev);
            return null;
          });
          console.log("close", reason);
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <div className="p-1 border-gray-300 border-2 pt-0 max-h-[300px] overflow-y-auto bg-gray-200">
          {sourceRefs.map((ref, index) => (
            <div
              key={index}
              onClick={() => {
                setAnchorEl(null);
                clickRef(ref);
              }}
              className="border border-gray-300 w-[400px] p-2 max-h-[120px] mt-1 cursor-pointer bg-gray-100 text-gray-600 rounded-md transition-all duration-300"
            >
              <div className="text-gray-600 text-[12px] font-bold">
                {ref.docTitle} : (Pg{ref.pageNum})
              </div>
              {/* <div className="text-[12px]">Page {ref.pageNum}</div> */}
              <div className="text-[10px] w-full h-[46px]  line-clamp-3">
                {ref.smallContext}
              </div>
              <div className="text-[10px] text-gray-500 mt-1">
                <Telescope className="inline-block mr-1 w-[12px]" />
                Open Source
              </div>
            </div>
          ))}
        </div>
      </Popover>
    </>
  );
};

export default CiteNumber;
